/**
 * SDL Divider Bar Configuration Options
 * -------------------------------------
 * Uses the user-supplied technical line drawings (PNG). The Technical page
 * inverts them via CSS so the stark white background drops out against the
 * dark theme and the black profile lines render as bright ivory strokes.
 */

const A = (u) => u;

export const DIVIDER_BARS = [
  {
    id: "SDL-01",
    name: "Slim Ridge",
    spec: "20.6 × 11 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/nqjfjzor_Screenshot%202026-09-27%20at%209.42.40%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-02",
    name: "House Ridge",
    spec: "20 × 12 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/7hghjuvi_Screenshot%202026-09-27%20at%209.42.44%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-03",
    name: "Flat T-Astragal",
    spec: "22 × 9 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/e5y327qb_Screenshot%202026-09-27%20at%209.42.49%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-04",
    name: "Micro Chevron",
    spec: "18 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/2b08vm66_Screenshot%202026-09-27%20at%209.42.56%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-05",
    name: "Compact Pyramid",
    spec: "17.7 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/sdtgbd7m_Screenshot%202026-09-27%20at%209.43.02%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-06",
    name: "Low Chevron",
    spec: "20 × 9 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/gmv2rya4_Screenshot%202026-09-27%20at%209.43.34%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-07",
    name: "Segmented Dome",
    spec: "30 × 15.7 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/lhwdqg3c_Screenshot%202026-09-27%20at%209.43.45%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-08",
    name: "Stepped Chevron",
    spec: "22.5 × 8 mm · JMGR6037HA",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/j5mvzzz2_Screenshot%202026-09-27%20at%209.43.52%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-09",
    name: "Bevelled Trapezoid",
    spec: "30 × 15 mm · GR75A27",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/enhmiwjl_Screenshot%202026-09-27%20at%209.43.57%E2%80%AFPM.png"
    ),
  },
  {
    id: "SDL-10",
    name: "Tall Pyramid",
    spec: "22 × 15 mm",
    image: A(
      "https://customer-assets-rejwkqb3.emergentagent.net/job_7c966369-8b86-4034-b768-cad248e60af9/artifacts/1my27782_Screenshot%202026-09-27%20at%209.44.20%E2%80%AFPM.png"
    ),
  },
];

export default DIVIDER_BARS;
